import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import PasswordInput from '../components/PasswordInput';
import { useAuth } from '../context/AuthContext';
import './Auth.scss';

const Connexion = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    remember: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData.email, formData.password);
    
    if (result.success) {
      if (result.needsPayment) {
        navigate('/inscription');
      } else {
        navigate('/dashboard');
      }
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <PageHeader 
        title="Connexion" 
        subtitle="Accédez à votre espace personnel"
      />

      <div className="auth-container">
        <div className="auth-split-layout">
          <div className="auth-left-section">
            <div className="auth-content">
              <h2>Bon retour !</h2>
              <p className="intro-text">
                Connectez-vous pour accéder à votre espace membre.
              </p>
              
              <div className="features-list">
                <div className="feature-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Programmes de formation</span>
                </div>
                <div className="feature-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Tableau de bord personnalisé</span>
                </div>
                <div className="feature-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Certificats et badges</span>
                </div>
                <div className="feature-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Événements exclusifs</span>
                </div>
              </div>
            </div>
          </div>

          <div className="auth-right-section">
            <div className="auth-card login-card">
            <div className="auth-header compact">
              <h2>Bienvenue</h2>
            </div>

            {error && (
              <div className="alert alert-error">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="15" y1="9" x2="9" y2="15"/>
                  <line x1="9" y1="9" x2="15" y2="15"/>
                </svg>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="votre.email@exemple.com"
                />
              </div>

              <PasswordInput
                id="password"
                name="password"
                label="Mot de passe"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="••••••••"
              />

              <div className="form-options">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="remember"
                    checked={formData.remember}
                    onChange={handleChange}
                  />
                  <span>Se souvenir de moi</span>
                </label>
                <Link to="/mot-de-passe-oublie" className="forgot-link">
                  Mot de passe oublié ?
                </Link>
              </div>

              <button type="submit" className="auth-submit-btn" disabled={loading}>
                {loading ? 'Connexion en cours...' : 'Se connecter'}
              </button>

              <div className="auth-footer">
                <p>Vous n'avez pas de compte ? <Link to="/inscription">S'inscrire</Link></p>
              </div>
            </form>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Connexion;
